import styled from "@emotion/styled";
import type { FunctionComponent } from "react";

import type { ContentSchemaRenderProps, RenderComponent } from "~/components/schema-render/content";

import { StyledBlockquote, StyledFigcaption, StyledFigure, StyledQuoteIcon } from "./styles";

type Props = ContentSchemaRenderProps;

const Component: FunctionComponent<Props> = ({ schemaNode }) => {
  const [quoteNode, sourceNode] = schemaNode.children ?? [];

  return (
    <StyledFigure>
      <StyledQuoteIcon />
      <StyledBlockquote>{quoteNode?.data}</StyledBlockquote>
      <StyledFigcaption>{sourceNode?.data}</StyledFigcaption>
    </StyledFigure>
  );
};

Component.displayName = "StyleArticleBlockquoteQuote";

export const StyleArticleBlockquoteQuote: RenderComponent<Props> = styled(Component)``;
StyleArticleBlockquoteQuote.isHandlingOwnChildren = true;
